(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["goose-hatbar-page"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('goose-hatbar-page')) customElements.define('goose-hatbar-page',class extends HTMLElement{
  connectedCallback(){
    if(this.abort)return;
    this.abort=new AbortController();
    const signal=this.abort.signal;
    this.setupHelpNavigation(signal);
    this.querySelectorAll('template[data-ghp-idea]').forEach(template=>{
      const target=this.querySelector('[data-hb-step="'+template.dataset.ghpIdea+'"] .ghb-rail');
      if(target&&!target.querySelector('.ghp-idea-card'))target.append(template.content.cloneNode(true));
    });
    this.addEventListener('input',event=>{
      if(event.target.matches('[data-hb-initials]'))event.target.value=event.target.value.replace(/[^a-zA-Z]/g,'').slice(0,3).toUpperCase();
    },{capture:true,signal});
    this.setupBandZoom(signal);
    this.setupDetailsMotion(signal);
    const rail=this.querySelector('.ghp-review-rail');
    this.motion=matchMedia('(prefers-reduced-motion: reduce)');
    this.hovered=false;this.paused=false;this.holding=false;this.until=0;this.last=0;
    this.addEventListener('click',event=>{
      const pause=event.target.closest('[data-ghp-pause]');
      if(pause){const paused=pause.closest('.ghp-benefits').classList.toggle('is-paused');pause.setAttribute('aria-pressed',String(paused));return;}
      const reviewPause=event.target.closest('[data-ghp-review-pause]');
      if(reviewPause){this.paused=!this.paused;reviewPause.setAttribute('aria-pressed',String(this.paused));return;}
      const direction=event.target.closest('[data-ghp-review-direction]');
      if(direction&&rail){this.until=performance.now()+2500;rail.scrollBy({left:Number(direction.dataset.ghpReviewDirection)*rail.clientWidth*.85,behavior:this.motion.matches?'instant':'smooth'});}
    },{signal});
    if(!rail)return;
    const originals=Array.from(rail.children);
    originals.forEach(card=>{
      const clone=card.cloneNode(true);clone.dataset.ghpClone='';clone.setAttribute('aria-hidden','true');
      clone.querySelectorAll('a,button,summary,[tabindex]').forEach(el=>el.tabIndex=-1);
      rail.append(clone);
    });
    const measure=()=>{
      rail.querySelectorAll('[data-ghp-clone]').forEach(el=>el.hidden=this.motion.matches);
      rail.classList.toggle('is-moving',!this.motion.matches);
      this.loop=originals.length?rail.children[originals.length].offsetLeft-originals[0].offsetLeft:0;
      this.position=rail.scrollLeft;
    };
    this.observer=new ResizeObserver(measure);this.observer.observe(rail);measure();
    this.motion.addEventListener('change',measure,{signal});
    rail.addEventListener('pointerenter',()=>{this.hovered=true;},{signal});
    rail.addEventListener('pointerleave',()=>{this.hovered=false;},{signal});
    rail.addEventListener('pointerdown',()=>{this.holding=true;},{signal});
    window.addEventListener('pointerup',()=>{if(this.holding){this.holding=false;this.until=performance.now()+1800;}},{signal});
    window.addEventListener('pointercancel',()=>{this.holding=false;},{signal});
    rail.addEventListener('wheel',e=>{if(Math.abs(e.deltaX)>Math.abs(e.deltaY))this.until=performance.now()+1800;},{passive:true,signal});
    const tick=time=>{
      const delta=this.last?Math.min(time-this.last,64):0;this.last=time;
      const keyboardFocus=rail.matches(':focus-visible')||!!rail.querySelector(':focus-visible');
      const reading=!!rail.querySelector('details[open]');
      if(!this.motion.matches&&!this.paused&&!this.holding&&!keyboardFocus&&!reading&&time>this.until&&this.loop>0&&!document.hidden){
        if(Math.abs(rail.scrollLeft-this.position)>2)this.position=rail.scrollLeft;
        this.position=(this.position+28*(this.hovered?.82:1)*delta/1000)%this.loop;
        rail.scrollLeft=this.position;
      }else this.position=rail.scrollLeft;
      this.frame=requestAnimationFrame(tick);
    };
    this.frame=requestAnimationFrame(tick);
  }
  setupHelpNavigation(signal){
    const helpHashes=['#hatbar-talla','#hatbar-materiales'];
    this.querySelectorAll('.ghp-size-link a').forEach(link=>link.addEventListener('click',event=>{
      const target=this.querySelector(link.getAttribute('href'));
      if(!target)return;
      event.preventDefault();
      if(helpHashes.includes(location.hash))history.replaceState(history.state,'',location.pathname+location.search);
      target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});
    },{signal}));
    if(performance.getEntriesByType('navigation')[0]?.type==='reload'){
      if(helpHashes.includes(location.hash))history.replaceState(history.state,'',location.pathname+location.search);
      const reset=()=>window.scrollTo({top:0,left:0,behavior:'instant'});
      reset();
      window.addEventListener('pageshow',reset,{once:true,signal});
    }
  }
  setupBandZoom(signal){
    const dialog=this.querySelector('.ghp-zoom'),image=dialog.querySelector('[data-ghp-zoom-image]'),viewport=dialog.querySelector('.ghp-zoom-viewport'),toggle=dialog.querySelector('[data-ghp-zoom-toggle]');
    const nav=dialog.querySelector('.ghp-gallery-nav'),thumbs=dialog.querySelector('.ghp-gallery-thumbs'),count=dialog.querySelector('[data-ghp-photo-count]');
    const status=dialog.querySelector('[data-ghp-gallery-status]'),photoCache=new Map();
    // Exclude only identified information slides, never product angles or colour photos.
    const informationFiles=['indiana-9434313','john-9397272','campestre-8044464','whatsapp_image_2026-09-02_at_10.12.16_am'];
    const isProductPhoto=item=>{
      if(!item.src)return false;
      const filename=new URL(item.src,location.href).pathname.split('/').pop().toLowerCase();
      const description=(filename+' '+(item.alt||'')).normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();
      return !informationFiles.some(name=>filename.includes(name))&&!/(guia[\s_-]*(de[\s_-]*)?tallas|size[\s_-]*(guide|chart)|caracteristicas|ficha[\s_-]*tecnica)/.test(description);
    };
    let photos=[],index=0,swipe=null,requestId=0;
    const showPhoto=next=>{
      if(!photos.length)return;
      index=(next+photos.length)%photos.length;
      image.src=photos[index].src;image.alt=photos[index].alt;
      count.textContent=(index+1)+' / '+photos.length;
      viewport.classList.remove('is-zoomed');toggle.setAttribute('aria-pressed','false');viewport.scrollTo(0,0);
      thumbs.querySelectorAll('button').forEach((button,i)=>button.setAttribute('aria-pressed',String(i===index)));
      const active=thumbs.children[index];
      if(active)thumbs.scrollTo({left:Math.max(0,active.offsetLeft-thumbs.offsetLeft-thumbs.clientWidth/2+active.clientWidth/2),behavior:'instant'});
    };
    const sizeGuide=this.querySelector('[data-ghp-size-guide]');
    sizeGuide?.addEventListener('click',()=>{
      requestId++;
      photos=[{src:sizeGuide.dataset.ghpSizeGuide,alt:sizeGuide.textContent.trim()}];
      dialog.querySelector('h2').textContent=sizeGuide.textContent.trim();
      dialog.querySelector('[data-ghp-zoom-name]').textContent='';
      status.hidden=true;image.hidden=false;toggle.hidden=false;nav.hidden=true;thumbs.hidden=true;
      thumbs.replaceChildren();dialog.classList.remove('has-gallery');
      this.zoomReturn=sizeGuide;dialog.showModal();showPhoto(0);
    },{signal});
    this.querySelectorAll('[data-hb-product]').forEach(card=>{
      const kind=card.dataset.hbKind;if(kind!=='band')return;
      const photo=card.querySelector('img');if(!photo)return;
      let wrapper=card.parentElement;
      if(wrapper.classList.contains('ghb-preview-card'))wrapper.classList.add('ghp-band-item');
      else if(!wrapper.classList.contains('ghp-band-item')){wrapper=document.createElement('div');wrapper.className='ghp-band-item';card.before(wrapper);wrapper.append(card);}
      wrapper.querySelector('.ghp-zoom-open')?.remove();
      const button=this.querySelector(kind==='hat'?'[data-ghp-gallery-button]':'[data-ghp-zoom-button]').content.firstElementChild.cloneNode(true);wrapper.append(button);
      button.addEventListener('click',async()=>{
        const currentRequest=++requestId;
        const url=new URL(photo.getAttribute('src'),location.href);url.searchParams.set('width','1600');
        const template=Array.from(this.querySelectorAll('[data-ghp-hat-photos]')).find(el=>el.dataset.ghpHatPhotos===card.dataset.hbProduct);
        photos=kind==='hat'&&template?Array.from(template.content.querySelectorAll('[data-photo-src]'),el=>({src:el.dataset.photoSrc,alt:el.dataset.photoAlt})):[];
        const embeddedPhotos=photos.filter(isProductPhoto);
        dialog.querySelector('h2').textContent=button.textContent;
        dialog.querySelector('[data-ghp-zoom-name]').textContent=card.querySelector('strong').textContent;
        this.zoomReturn=button;dialog.showModal();
        image.hidden=true;nav.hidden=true;thumbs.hidden=true;toggle.hidden=true;dialog.classList.remove('has-gallery');
        status.hidden=false;status.textContent=status.dataset.loading;
        if(kind==='hat'){
          try{
            const productUrl=new URL(card.dataset.hbUrl,location.href);
            productUrl.pathname=productUrl.pathname.replace(/\/$/,'')+'.js';productUrl.search='';productUrl.hash='';
            if(!photoCache.has(productUrl.href))photoCache.set(productUrl.href,fetch(productUrl.href,{signal,credentials:'same-origin'}).then(response=>{if(!response.ok)throw new Error('gallery');return response.json();}).catch(error=>{photoCache.delete(productUrl.href);throw error;}));
            const product=await photoCache.get(productUrl.href);
            if(currentRequest!==requestId||!dialog.open||signal.aborted)return;
            photos=(product.images||[]).map(item=>{
              const src=typeof item==='string'?item:item.src;
              const media=(product.media||[]).find(entry=>entry.media_type==='image'&&entry.src?.split('?')[0]===src?.split('?')[0]);
              return {src,alt:media?.alt||item.alt||product.title||photo.alt};
            }).filter(isProductPhoto);
            if(!photos.length)throw new Error('gallery');
          }catch(error){
            if(currentRequest!==requestId||!dialog.open||signal.aborted)return;
            photos=embeddedPhotos;
            if(!photos.length){status.textContent=status.dataset.error;return;}
          }
        }else photos=[{src:url.href,alt:photo.alt}];
        status.hidden=true;image.hidden=false;toggle.hidden=false;
        thumbs.replaceChildren();
        photos.forEach((item,i)=>{
          if(photos.length<2)return;
          const thumb=document.createElement('button');thumb.type='button';thumb.dataset.photoIndex=i;thumb.setAttribute('aria-label',(i+1)+' / '+photos.length+' · '+item.alt);
          const img=document.createElement('img'),src=new URL(item.src,location.href);src.searchParams.set('width','160');
          img.src=src.href;img.alt='';img.width=64;img.height=64;img.loading='lazy';thumb.append(img);thumbs.append(thumb);
        });
        const multiple=photos.length>1;nav.hidden=!multiple;thumbs.hidden=!multiple;dialog.classList.toggle('has-gallery',multiple);
        showPhoto(0);
      },{signal});
    });
    nav.querySelector('[data-ghp-photo-prev]').addEventListener('click',()=>showPhoto(index-1),{signal});
    nav.querySelector('[data-ghp-photo-next]').addEventListener('click',()=>showPhoto(index+1),{signal});
    thumbs.addEventListener('click',event=>{const button=event.target.closest('[data-photo-index]');if(button)showPhoto(Number(button.dataset.photoIndex));},{signal});
    dialog.addEventListener('keydown',event=>{
      if(viewport.classList.contains('is-zoomed')||photos.length<2)return;
      if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();showPhoto(index+(event.key==='ArrowRight'?1:-1));}
    },{signal});
    viewport.addEventListener('pointerdown',event=>{swipe={x:event.clientX,y:event.clientY};},{signal});
    viewport.addEventListener('pointerup',event=>{
      if(swipe&&!viewport.classList.contains('is-zoomed')){const dx=event.clientX-swipe.x,dy=event.clientY-swipe.y;if(Math.abs(dx)>55&&Math.abs(dx)>Math.abs(dy))showPhoto(index+(dx<0?1:-1));}swipe=null;
    },{signal});
    viewport.addEventListener('pointercancel',()=>{swipe=null;},{signal});
    dialog.querySelector('[data-ghp-zoom-close]').addEventListener('click',()=>dialog.close(),{signal});
    dialog.addEventListener('close',()=>{requestId++;this.zoomReturn?.focus({preventScroll:true});},{signal});
    toggle.addEventListener('click',()=>{
      const zoomed=viewport.classList.toggle('is-zoomed');toggle.setAttribute('aria-pressed',String(zoomed));
      requestAnimationFrame(()=>viewport.scrollTo({left:zoomed?(viewport.scrollWidth-viewport.clientWidth)/2:0,top:zoomed?(viewport.scrollHeight-viewport.clientHeight)/2:0,behavior:'instant'}));
    },{signal});
  }
  setupDetailsMotion(signal){
    const strip=this.querySelector('.ghp-details'),pause=this.querySelector('[data-ghp-details-pause]'),mobile=matchMedia('(max-width:749px)'),reduced=matchMedia('(prefers-reduced-motion:reduce)');
    let paused=false,holding=false,visible=false,until=performance.now()+1800,last=0,pos=strip.scrollLeft,direction=1;
    const update=()=>{strip.classList.toggle('is-auto',mobile.matches&&!reduced.matches);pause.hidden=!mobile.matches||reduced.matches;};
    update();mobile.addEventListener('change',update,{signal});reduced.addEventListener('change',update,{signal});
    this.detailsObserver=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;},{threshold:.2});this.detailsObserver.observe(strip);
    pause.addEventListener('click',()=>{paused=!paused;pause.setAttribute('aria-pressed',String(paused));},{signal});
    strip.addEventListener('pointerdown',()=>{holding=true;},{signal});
    const release=()=>{if(holding){holding=false;until=performance.now()+3000;}};
    window.addEventListener('pointerup',release,{signal});window.addEventListener('pointercancel',release,{signal});
    strip.addEventListener('wheel',()=>{until=performance.now()+3000;},{signal,passive:true});
    const tick=time=>{
      const delta=last?Math.min(time-last,64):0;last=time;
      const max=strip.scrollWidth-strip.clientWidth;
      if(mobile.matches&&!reduced.matches&&!paused&&!holding&&visible&&!document.hidden&&time>until&&!strip.matches(':focus-visible')&&max>0){
        if(Math.abs(strip.scrollLeft-pos)>2)pos=strip.scrollLeft;
        pos=Math.max(0,Math.min(max,pos+direction*18*delta/1000));strip.scrollLeft=pos;
        if(pos>=max||pos<=0){direction*=-1;until=time+2000;}
      }else pos=strip.scrollLeft;
      this.detailsFrame=requestAnimationFrame(tick);
    };
    this.detailsFrame=requestAnimationFrame(tick);
  }
  disconnectedCallback(){
    cancelAnimationFrame(this.detailsFrame);this.detailsObserver?.disconnect();this.querySelector('.ghp-zoom')?.close();
    cancelAnimationFrame(this.frame);this.observer?.disconnect();this.abort?.abort();this.abort=null;
    this.querySelectorAll('[data-ghp-clone]').forEach(el=>el.remove());
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["goose-home-story"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('goose-home'))customElements.define('goose-home',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>this.startHall(),{once:true});else this.startHall();this.addEventListener('click',event=>{const guide=event.target.closest('a[href="#goose-home-talla"]');if(guide){const target=this.querySelector('#goose-home-talla');if(target)target.open=true}const tab=event.target.closest('[data-tab]');if(tab){this.selectTab(tab);return}const pause=event.target.closest('[data-pause]');if(pause){const scope=pause.closest('[data-motion]');const paused=scope.classList.toggle('is-paused');pause.setAttribute('aria-pressed',String(paused));pause.textContent=paused?'▶':'Ⅱ';return}const control=event.target.closest('[data-scroll]');if(control){const scope=control.closest('.gwh-shopping,.gwh-feature__shop,.gwh-hall,.gwh-palma-sale');const rail=scope.querySelector('[data-panel]:not([hidden]) .gwh-rail')||scope.querySelector('.gwh-rail');if(scope?.classList.contains('gwh-hall'))this.hallHold=performance.now()+6000;if(rail)rail.scrollBy({left:rail.clientWidth*.9*Number(control.dataset.scroll),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'})}});this.addEventListener('keydown',event=>{const current=event.target.closest('[data-tab]');if(!current||!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;event.preventDefault();const tabs=[...this.querySelectorAll('[data-tab]')];const next=event.key==='Home'?tabs[0]:event.key==='End'?tabs[tabs.length-1]:tabs[(tabs.indexOf(current)+(event.key==='ArrowRight'?1:tabs.length-1))%tabs.length];this.selectTab(next);next.focus()})}selectTab(selected){this.querySelectorAll('[data-tab]').forEach(tab=>{const active=tab===selected;tab.setAttribute('aria-selected',String(active));tab.tabIndex=active?0:-1});this.querySelectorAll('[data-panel]').forEach(panel=>panel.hidden=panel.dataset.panel!==selected.dataset.tab)}startHall(){
  if(this.hallFrame)return;
  const rail=this.querySelector('.gwh-hall__rail');
  if(!rail||matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  this.hallVisible=true;
  this.hallHold=0;
  let direction=1,last=0,position=rail.scrollLeft;
  if('IntersectionObserver' in window){
    this.hallObserver=new IntersectionObserver(entries=>{this.hallVisible=entries[0].isIntersecting},{threshold:0});
    this.hallObserver.observe(rail);
  }
  const hold=()=>{this.hallHold=performance.now()+3000;position=rail.scrollLeft};
  let pointerOrigin=null;
  rail.addEventListener('pointerdown',event=>{pointerOrigin={x:event.clientX,y:event.clientY}},{passive:true});
  rail.addEventListener('pointermove',event=>{
    if(!pointerOrigin)return;
    const dx=Math.abs(event.clientX-pointerOrigin.x),dy=Math.abs(event.clientY-pointerOrigin.y);
    if(dx>8&&dx>dy)hold();
  },{passive:true});
  ['pointerup','pointercancel','pointerleave'].forEach(name=>rail.addEventListener(name,()=>{pointerOrigin=null},{passive:true}));
  rail.addEventListener('wheel',event=>{if(Math.abs(event.deltaX)>Math.abs(event.deltaY))hold()},{passive:true});
  const step=time=>{
    if(!this.isConnected)return;
    const delta=last?Math.min(time-last,50):0;
    last=time;
    const keyboardFocus=rail.matches(':focus-visible')||rail.querySelector('a:focus-visible');
    if(this.hallVisible&&!keyboardFocus&&!document.hidden&&time>this.hallHold){
      const max=Math.max(0,rail.scrollWidth-rail.clientWidth);
      if(max>0){
        position=Math.max(0,Math.min(max,position+direction*delta*.045));
        rail.scrollTo({left:position,behavior:'instant'});
        if(position>=max)direction=-1;
        else if(position<=0)direction=1;
      }
    }else position=rail.scrollLeft;
    this.hallFrame=requestAnimationFrame(step);
  };
  this.hallFrame=requestAnimationFrame(step);
}disconnectedCallback(){this.hallObserver?.disconnect();if(this.hallFrame)cancelAnimationFrame(this.hallFrame);this.hallFrame=null}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["goose-john-editorial"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const setup = (root) => {
      const sections = root.matches?.('[data-gw-john-editorial]')
        ? [root]
        : root.querySelectorAll('[data-gw-john-editorial]');
      sections.forEach((section) => {
        if (section.dataset.gwJohnReady) return;
        section.dataset.gwJohnReady = 'true';
        section.querySelectorAll('[data-gw-ticker]').forEach((ticker) => {
        const tickerToggle = ticker.querySelector('[data-gw-ticker-toggle]');
        tickerToggle?.addEventListener('click', () => {
          const paused = ticker.dataset.paused !== 'true';
          ticker.dataset.paused = String(paused);
          tickerToggle.setAttribute('aria-pressed', String(paused));
          tickerToggle.setAttribute('aria-label', paused ? tickerToggle.dataset.resume : tickerToggle.dataset.pause);
          tickerToggle.textContent = paused ? '▶' : 'Ⅱ';
        });
        });
        section.querySelectorAll('[data-gw-carousel]').forEach((carousel) => {
        const track = carousel.querySelector('[data-gw-john-track]');
        const move = (direction) => {
          const card = track.querySelector('.gw-john__card, .gw-john__story');
          if (!card) return;
          const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
          track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        };
        carousel.querySelector('[data-gw-john-prev]').addEventListener('click', () => move(-1));
        carousel.querySelector('[data-gw-john-next]').addEventListener('click', () => move(1));
        });
      });
    };
    setup(document);
    document.addEventListener('shopify:section:load', (event) => setup(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["goose-summer-landing"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = (root) => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const video = root.querySelector('[data-gsv-video]');
    const toggle = root.querySelector('[data-gsv-video-toggle]');
    const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
    const setVideoState = (playing) => {
      root.classList.toggle('is-playing', playing);
      if (playing) root.classList.add('has-played');
      if (toggle) {
        toggle.setAttribute('aria-label', playing ? root.dataset.pause : root.dataset.play);
        toggle.querySelector('span').textContent = playing ? 'Ⅱ' : '▶';
      }
    };
    if (video && toggle) {
      toggle.hidden = false;
      video.muted = true;
      const mobileSource = video.querySelector('source[media]');
      if (mobileSource && matchMedia(mobileSource.media).matches) video.src = mobileSource.src;
      video.addEventListener('playing', () => setVideoState(true));
      video.addEventListener('pause', () => setVideoState(false));
      toggle.addEventListener('click', () => {
        if (video.paused) video.play().catch(() => setVideoState(false));
        else video.pause();
      });
      if (!reducedMotion.matches && !navigator.connection?.saveData) video.play().catch(() => setVideoState(false));
      reducedMotion.addEventListener('change', (event) => { if (event.matches) video.pause(); });
      new IntersectionObserver((entries) => { if (!entries[0].isIntersecting) video.pause(); }, { threshold: 0 }).observe(video);
    }

    root.querySelectorAll('[data-gsv-motion]').forEach((motion) => {
      const control = motion.querySelector('[data-gsv-motion-toggle]');
      let userPaused = reducedMotion.matches;
      const renderMotion = () => {
        control.hidden = reducedMotion.matches;
        motion.classList.toggle('is-paused', userPaused || reducedMotion.matches);
        control.setAttribute('aria-pressed', String(userPaused || reducedMotion.matches));
        control.setAttribute('aria-label', userPaused || reducedMotion.matches ? root.dataset.motionPlay : root.dataset.motionPause);
        control.querySelector('span').textContent = userPaused || reducedMotion.matches ? '▶' : 'Ⅱ';
      };
      control.addEventListener('click', () => { userPaused = !userPaused; renderMotion(); });
      reducedMotion.addEventListener('change', renderMotion);
      renderMotion();
    });
    const cards = [...root.querySelectorAll('[data-gsv-card]')];
    const filters = [...root.querySelectorAll('[data-gsv-filter]')];
    const more = root.querySelector('[data-gsv-more]');
    const count = root.querySelector('[data-gsv-count]');
    let filter = 'all';
    let expanded = false;
    const update = () => {
      const matching = cards.filter((card) => filter === 'all' || card.dataset.material === filter);
      cards.forEach((card) => { card.hidden = !matching.includes(card) || (!expanded && matching.indexOf(card) > 3); });
      count.textContent = `${matching.length} ${count.dataset.label}`;
      more.hidden = expanded || matching.length <= 4;
      more.setAttribute('aria-expanded', String(expanded));
      filters.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.gsvFilter === filter)));
    };
    filters.forEach((button) => button.addEventListener('click', () => { filter = button.dataset.gsvFilter; expanded = false; update(); }));
    more.addEventListener('click', () => { expanded = true; update(); });
    update();
    const detailButtons = [...root.querySelectorAll('[data-gsv-detail]')];
    const panels = [...root.querySelectorAll('[data-gsv-panel]')];
    detailButtons.forEach((button) => button.addEventListener('click', () => {
      detailButtons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
      panels.forEach((panel) => { panel.hidden = panel.dataset.gsvPanel !== button.dataset.gsvDetail; });
    }));
    const dialog = root.querySelector('[data-gsv-dialog]');
    const zoomImage = root.querySelector('[data-gsv-zoom-image]');
    root.querySelectorAll('[data-gsv-zoom]').forEach((link) => link.addEventListener('click', (event) => {
      if (!dialog?.showModal) return;
      event.preventDefault();
      zoomImage.src = link.href;
      zoomImage.alt = link.closest('figure').querySelector('img').alt;
      dialog.showModal();
    }));
    dialog?.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
  };
  document.querySelectorAll('[data-goose-summer]').forEach(initialize);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-goose-summer]').forEach(initialize));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["goose-yellowstone-hero"] && !Shopify.designMode) return;
  try {
    

  (() => {
    const setup = (root) => {
      const sections = root.matches?.('[data-gw-john-editorial]')
        ? [root]
        : root.querySelectorAll('[data-gw-john-editorial]');
      sections.forEach((section) => {
        if (section.dataset.gwJohnReady) return;
        section.dataset.gwJohnReady = 'true';
        section.querySelectorAll('[data-gw-carousel]').forEach((carousel) => {
        const track = carousel.querySelector('[data-gw-john-track]');
        const move = (direction) => {
          const card = track.querySelector('.gw-john__card, .gw-john__story');
          if (!card) return;
          const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
          track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        };
        carousel.querySelector('[data-gw-john-prev]').addEventListener('click', () => move(-1));
        carousel.querySelector('[data-gw-john-next]').addEventListener('click', () => move(1));
        });
      });
    };
    setup(document);
    document.addEventListener('shopify:section:load', (event) => setup(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const gooseWelcomeBanner = document.querySelector('[data-goose-welcome-discount]');
  if (gooseWelcomeBanner) {
    const updateGooseHeaderOffset = () => document.documentElement.style.setProperty('--goose-welcome-height', gooseWelcomeBanner.getBoundingClientRect().height + 'px');
    new ResizeObserver(updateGooseHeaderOffset).observe(gooseWelcomeBanner);
    updateGooseHeaderOffset();
  }

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["welcome-discount-banner"]) return;
  try {
    
  (() => {
    const updateWelcomeDiscountBanners = (root = document) => {
      root.querySelectorAll('[data-goose-welcome-discount]').forEach((banner) => {
        const discountCode = banner.dataset.discountCode;
        const hasDiscount = document.cookie.split(';').some((cookiePart) => {
          const [name, ...valueParts] = cookiePart.trim().split('=');
          const value = decodeURIComponent(valueParts.join('='));
          return name === 'discount_code' && value === discountCode;
        });

        banner.hidden = !hasDiscount;
      });
    };

    const initializeWelcomeDiscountBanners = () => updateWelcomeDiscountBanners();

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeWelcomeDiscountBanners, { once: true });
    } else {
      initializeWelcomeDiscountBanners();
    }

    document.addEventListener('shopify:section:load', (event) => {
      updateWelcomeDiscountBanners(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["welcome-email-popup"]) return;
  try {
    
  (() => {
    const dismissedKey = 'gooseEmailPopupDismissedAt';
    const subscribedKey = 'gooseEmailPopupSubscribed';

    const hasDiscountCookie = () => document.cookie.split(';').some((cookiePart) => {
      const [name, ...valueParts] = cookiePart.trim().split('=');
      const value = decodeURIComponent(valueParts.join('='));
      return name === 'discount_code' && value === 'BIENVENIDAGOOSE10';
    });

    const initializePopup = (section) => {
      const dialog = section.querySelector('dialog');
      const closeButton = section.querySelector('[data-goose-email-popup-close]');
      const success = section.querySelector('[data-goose-email-popup-success]');
      const form = section.querySelector('form');
      const delay = Number(section.dataset.delay) || 5000;
      const hideDays = Number(section.dataset.hideDays) || 7;
      const dismissedAt = Number(localStorage.getItem(dismissedKey)) || 0;
      const dismissalIsActive = Date.now() - dismissedAt < hideDays * 86400000;

      if (!dialog || !closeButton || dialog.dataset.initialized === 'true') return;
      dialog.dataset.initialized = 'true';

      const dismiss = () => {
        localStorage.setItem(dismissedKey, String(Date.now()));
        if (dialog.open) dialog.close();
      };

      closeButton.addEventListener('click', dismiss);
      dialog.addEventListener('cancel', () => {
        localStorage.setItem(dismissedKey, String(Date.now()));
      });
      section.addEventListener('click', (event) => {
        if (event.target === section) dismiss();
      });
      dialog.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          event.preventDefault();
          dismiss();
        }
      });

      if (success) {
        localStorage.setItem(subscribedKey, 'true');
        dialog.show();
        return;
      }

      if (section.querySelector('[role="alert"]')) {
        dialog.show();
        return;
      }

      const openFromLink = () => {
        if (form && window.location.hash === '#' + form.id && !dialog.open) dialog.show();
      };
      window.addEventListener('hashchange', openFromLink);
      openFromLink();
      if (dialog.open) return;

      if (hasDiscountCookie() || localStorage.getItem(subscribedKey) === 'true' || dismissalIsActive) return;

      window.setTimeout(() => {
        if (!dialog.open) dialog.show();
      }, delay);
    };

    const initializeAllPopups = (root = document) => {
      root.querySelectorAll('[data-goose-email-popup]').forEach(initializePopup);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAllPopups(), { once: true });
    } else {
      initializeAllPopups();
    }

    document.addEventListener('shopify:section:load', (event) => initializeAllPopups(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
